import { render, staticRenderFns } from "./ManagerSearch.vue?vue&type=template&id=2871aa8f&scoped=true&"
import script from "./ManagerSearch.vue?vue&type=script&lang=js&"
export * from "./ManagerSearch.vue?vue&type=script&lang=js&"
import style0 from "./ManagerSearch.vue?vue&type=style&index=0&id=2871aa8f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2871aa8f",
  null
  
)

export default component.exports